import { Component, OnInit } from '@angular/core';
import { PictureService } from '../../../services/picture.service';
import { Picture } from 'src/models/picture';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {
  currentPicture: Picture;
  pictureContainer: JQuery<HTMLElement>;

  constructor(
    protected pictureService: PictureService
  ) {
  }

  ngOnInit(): void {
    this.pictureContainer = $('.img-wrapper .picture');
    this.pictureService._pictureCast.subscribe(picture => {
      if (this.currentPicture) {
        this.hidePicture().subscribe(() => {
          this.currentPicture = picture;
        });
      } else {
        this.currentPicture = picture;
      }
    });
  }

  getIndexLegend() {
    return `${this.pictureService.getCurrentPictureIndex()} / ${this.pictureService.getNumberOfPictures()}`;
  }

  close() {
    this.pictureService.preview();
  }

  hidePicture(): Observable<boolean> {
    return new Observable(subscriber => {
      this.pictureContainer.fadeOut(500, () => {
        subscriber.next(true);
        subscriber.complete();
      });
    });
  }

  showPicture() {
    this.pictureContainer.fadeIn(500);
  }

  previous() {
    this.pictureService.getPreviousPicture();
  }

  next() {
    this.pictureService.getNextPicture();
  }

  isLastPreview() {
    return this.pictureService.isLastPicture();
  }

  isFirstPreview() {
    return this.pictureService.isFirstPicture();
  }

}
